import React from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";

const testData = [
  { id: 1, name: "Item 1" },
  { id: 2, name: "Item 2" },
  { id: 3, name: "Item 3" },
];

export default function KendoGridDetailTest() {
  const [detailExpand, setDetailExpand] = React.useState({});

  const handleDetailExpandChange = (event) => {
    if (!event.dataItem) return;
    const id = event.dataItem.id;
    setDetailExpand((prev) => {
      const next = { ...prev, [id]: !prev[id] };
      return next;
    });
  };

  return (
    <Grid
      style={{ height: 400 }}
      data={testData}
      detail={(props) => <div>Detail for {props.dataItem.name}</div>}
      detailExpand={detailExpand}
      onDetailExpandChange={handleDetailExpandChange}
      dataItemKey="id"
    >
      <Column field="id" title="ID" width="50px" />
      <Column field="name" title="Name" />
    </Grid>
  );
}
